import * as Factory from 'factory.ts'
import faker from 'faker'

import { EntityFactory } from '@webapp/core/utils/mocks/EntityFactory'
import { User, type UserConstructorData } from './User'

export const UserConstructorFactory =
  Factory.Sync.makeFactory<UserConstructorData>({
    id: Factory.each(() => faker.random.number()),
    firstName: Factory.each(() => faker.name.firstName()),
    lastName: Factory.each(() => faker.name.lastName()),
    profileImage: null,
  })

export const UserFactory = EntityFactory(User, UserConstructorFactory)
